<script>
export default {
    props: {
        isActive: {
            type: Boolean,
            default: false
        },
        index: Number
    },
    name: "mineOption",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        // 选中
        choose() { 
            // console.log(this.$parent)
            this.$parent.$data.isActive = false;
            this.$emit('click');
        },
    },
};
</script>

<template>
    <div class="mine_option" :class="{active: isActive}" @click="choose"><slot></slot></div>
</template>

<style scoped lang="scss">
.mine_option{
    padding: 0 .1rem;
    height: .35rem;
    cursor: pointer;
    line-height: .35rem;
    cursor: pointer;
    &.active,
    &:hover{
        background: #f1f1f1;
    }
}
</style>